mutation MessageTravelerCreate($input: MessageTravelerCreateInput!) {
  messageTravelerCreate(input: $input) {
    userMessages {
      id
      _rowTimestamp
      _createdDate
      messageComment
      _isIncomingMessage
      _isOutgoingMessage
      _sendingUser
      _recipientUser
      _notificationTitle
      _isUpdatable
      isResponseRequired
      linkId
      linkTitle
      linkType
      _respondedDate
      messageResponse
      _isNewMessage
      _isDeletable
      userMessageDetailsByThreadId(orderBy: _SORT_DATE_DESC) {
        nodes {
          id
          _recipientUser
          _recipientUserId
          _isDeletable
          _receivedDate
          _rowTimestamp
          _respondedDate
          messageResponse
        }
      }
    }
  }
}
